import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetCodingProfileByGuid = () => {
  const [loading, setLoading] = useState(false);
  const [codingProfile, setCodingProfile] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const getCodingProfileByGuid = guid => {
    if (!guid) return;

    setLoading(true);
    setCodingProfile(null);
    axiosClient
      .get('SettingProduct/CoddingProfile/Update', { params: { GUID: guid } })
      .then(res => {
        if (res.status === 200) {
          setCodingProfile(res.data.value ?? null);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  const resetCodingProfile = () => {
    setCodingProfile(null);
    setLoading(false);
  };

  return { getCodingProfileByGuid, codingProfile, loading, resetCodingProfile };
};

export default useGetCodingProfileByGuid;
